<template>
    <div id="main">
        <router-view></router-view>

        <ul :class="theme_css" :style="{bottom:pc_bottom}">
            <li>
                <router-link :to="{name: 'index'}" active-class="active" exact>
                    <div id="div_index" class="lnk-con" @click="tab(1)">
                        <div class="img-con">
                                <img :src="cur_index == 1 ? require('../assets/img/new/2024/index1.png') : require('../assets/img/new/2024/index.png')" class="nav-img-bottom" />
                        </div>
                        <div class="nav-lb">首页</div>
                    </div>
                </router-link>
            </li>
            <li>
                <router-link :to="{name: 'msg'}">
                    <div class="lnk-con" @click="tab(2)">
                        <div class="img-con">
                            <img :src="cur_index == 2 ? require('../assets/img/new/2024/msg1.png') : require('../assets/img/new/2024/msg.png')" class="nav-img-bottom" />
                            <div class="tag_red" v-if="noread_count > 0 || msg_noread > 0">
                                <span>{{ cur_index === 2 ? msg_noread : noread_count }}</span>
                            </div>
                        </div>
                        <div class="nav-lb">消息</div>
                    </div>
                </router-link>
            </li>
            <li>
                <router-link :to="{name: 'my'}">
                    <div class="lnk-con" @click="tab(3)">
                        <div class="img-con">
                            <img :src="cur_index == 3 ? require('../assets/img/new/2024/my1.png') : require('../assets/img/new/2024/my.png')" class="nav-img-bottom" />
                        </div>
                        <div class="nav-lb">我的</div>
                    </div>
                </router-link>
            </li>
        </ul>
        <div v-if="is_pc" class="beian">
              <a href="https://beian.miit.gov.cn/" target="_blank" style="color:#666;">鄂ICP备2021005009号</a>
        </div>
        <sayhello ref="sayHello"></sayhello>
    </div>
</template>

<script>
    import { mapMutations, mapActions } from "vuex";
    import * as tool from "../api/common";
    import SayHello from "../components/SayHello.vue"
    export default {
        components: {
            sayhello: SayHello
        },
        data() {
            return {
                cur_index: 1,
                is_pc:false,
                pc_bottom:0
            }
        },
        computed: {
            noread_count: function () {
                var message = this.$store.state.message;
                var noread = tool.calculate_noreadAll_count(message);
                return noread;
            },

            theme_css() {
                var rtn_css = "";
                var client = this.$store.state.client;
                var themeDark = tool.is_theme_dark(this);
                if (client.is_ios) {
                    rtn_css = themeDark == true ? "ios_dark" : "ios_light";
                } 
                if (client.is_andriod) {
                    rtn_css = themeDark == true ? "andriod_dark" : "andriod_light";
                }
                return rtn_css;
            },

            msg_noread() {
                var objVal = this.$store.state.objVal;
                var msg_noread = objVal.msg_noread;
                if (msg_noread == -1) {
                    msg_noread = this.noread_count;
                }
                return msg_noread;
            }
        },

        mounted() {
            this.cur_index = this.$store.state.index_tag;
            this.init_user();

            //首次进入的情况（从author页面跳转过来，强行显示首页）
            if (this.$route.params.from) {
                var from = this.$route.params.from;
                if (from == 'auth' || from == 'index2' || from == 'reg_complate') {
                    document.getElementById("div_index").click();
                }
            }

            //判断是否是PC端
             var client = this.$store.state.client;
             //console.log(JSON.stringify(client));
             if(client.is_pc){
                this.is_pc = true;
                this.pc_bottom = "1rem";
             }
            //console.log("is_pc:" + this.is_pc)
        },
        methods: {
            ...mapMutations(['get', 'post']), //引入方法
            ...mapActions(["act_get_userinfo"]), //引入方法

            tab(i) {
                this.cur_index = i;
                this.$store.commit('set_index_tag', i);
                //重置state录音状态
                this.$store.commit('set_objVal', {"voice_state":0});

                //存储在线动作
                var actions = {
                    1: "menu_index",
                    2: "menu_msg",
                    3: "menu_my"
                };
                var action_tag = actions[i];
                if (action_tag) {
                    tool.set_user_action(action_tag);
                }
            },
            init_user() {
                var uid = this.$store.state.uid;
                var self = this;
                self.act_get_userinfo({
                    uid: uid,
                    success: function (u) {
                        var loc_is_sayHello = localStorage.getItem('loc_is_sayHello');
                        //是否弹框批量打招呼
                        if(!loc_is_sayHello && u.reg_time <= 86400 * 1){
                            self.$refs.sayHello.show();
                        }
                    },
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    #main {
        width: 100%;
    }

    

    ul {
        list-style-type: none;
        display: flex;
        position: fixed;
        bottom: 0;
        margin: 0;
        padding: 0;
        width: 100%;
        height: 3.3rem;
        line-height: 3.3rem;
        background-color: #EDEDED;
        li {
            flex-grow: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            .active {
                color: #af5ee8;
            }
            a {
                color: #333;
                display: flex;
            }
            .nav-lb {
                height: 1.2rem;
                line-height: 1.2rem;
                margin-top: .1rem;
                font-size: .96rem;
            }
        }
    }
    .beian{
        font-size: .75rem;
        background-color: #EDEDED;
        width: 100%;
        text-align: center;
        position: fixed;
        bottom: 0;
        height: 1rem;
        line-height: 1rem;
    }

    .img-con {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                width: 1.5rem;
                height: 1.5rem;
                margin: auto;
                .nav-img-bottom {
                    display: flex;
                    width: 1.5rem;
                    height: 1.5rem;
                    margin: auto;
                }
                .tag_red {
                    height: 1.5rem;
                    width: 1.5rem;
                    font-size: 1rem;
                    margin-top: -1.5rem;
                    margin-left: 1rem;
                    span {
                        position: absolute;
                        display: inline-block;
                        border-radius: 50%;
                        background-color: red;
                        color: white;
                        height: 1rem;
                        padding: 0.1rem;
                        font-size: .75rem;
                        text-align: center;
                        line-height: 1rem;
                        min-width: 1rem;

                    }
                }
            }

    

    .ios_light {
        background-color: #F7F7F7;
    }
    .andriod_light {
        background-color: #EDEDED;
    }
    .ios_dark {
        background-color: #1E1E1E;
        .nav-lb {
            color: #DFDFDF;
        }
    }
    .andriod_dark {
        background-color: #111111;
        .nav-lb {
            color: #DFDFDF;
        }
    }
</style>